import axios from 'axios';
import { BASE_URL } from './apiconfig';
import { appendImpersonationParams } from './impersonationUtils';

export const getUserSpas = async (token: string | null, params: string) => {
  try {
    const queryString = appendImpersonationParams(params);
    const { data } = await axios.get(`${BASE_URL}/spas?${queryString}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to pull user spas list. ", error);
    throw error;
  }
}

export const getAUserSpas = async (token: string | null, params: {page:string, uuid:string}) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/user/${params.uuid}/spas?${params.page}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to pull user's spas list. ", error);
    throw error;
  }
}

export const getSpaStatuses = async (token: string | null) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/spas/connected`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to pull spa statuses. ", error);
    throw error;
  }
}

export const getSpaById = async (token: string | null, id: string) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/spas/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return data;
  } catch (error) {
    console.log("Failed to pull spa by id. ", error);
    throw error;
  }
}

// Edit profile API:
export const editSpaApi = async (token: string | null, updateInfo:{guid:string, nick_name?:any, dealership_id?:any,arctic_serial_number?:string}) => {
  try {
    const { data } = await axios.post(`${BASE_URL}/spas/${updateInfo.guid}`, updateInfo, {
      headers: { Authorization: `Bearer ${token}` }
    })
    return data;
  } catch (error) {
    throw error;
  }
};

export const editSpaModelApi = async (token: string | null, updateInfo:{guid:string, tub_model_id?:any}) => {
  try {
    const { data } = await axios.put(`${BASE_URL}/spas/${updateInfo.guid}/tub-model`, updateInfo, {
      headers: { Authorization: `Bearer ${token}` }
    })
    return data;
  } catch (error) {
    throw error;
  }
};


export const deleteSpaApi = async (token: string | null, id: string) => {
  try {
    const { data } = await axios.delete(`${BASE_URL}/admin/spas/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return data;
  } catch (error) {
    console.log("Failed to delete spa. ", error);
    throw error;
  }
}

export const deregisterSpaUserApi = async (token: string | null, spaInfo:{guid:string, user_id:string}) => {
  try {
    const { data } = await axios.post(`${BASE_URL}/spas/deregister`, {
      spa_id:spaInfo.guid
    },{
      headers: { Authorization: `Bearer ${token}` },
    })
    return data;
  } catch (error) {
    console.log("Failed to deregister spa. ", error);
    throw error;
  }
}

export const registerSpaUserApi = async (token: string | null, spaInfo:{guid:string, user_id:string}) => {
  try {
    const { data } = await axios.post(`${BASE_URL}/spas/register-to-user`, {
      spa_id:spaInfo.guid,
      user_id: spaInfo.user_id
    },{
      headers: { Authorization: `Bearer ${token}` },
    })
    return data;
  } catch (error) {
    console.log("Failed to deregister spa. ", error);
    throw error;
  }
}

export const flagSpaApi = async (token: string | null, guid:string) => {
  try {
    const { data } = await axios.put(`${BASE_URL}/spas/${guid}/flag`,{},{
      headers: { Authorization: `Bearer ${token}` },
    })
    return data;
  } catch (error) {
    console.log("Failed to flag spa. ", error);
    throw error;
  }
}

export const getFlaggedSpas = async (token: string | null, params: string) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/user/flagged-spas${params}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;

  } catch (error) {
    console.log("Failed to get user's flagged spas. ", error);
    throw error;
  }
};

export const getSpasCount = async (token: string | null) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/spas-count`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;

  } catch (error) {
    console.log("Failed to get spas count. ", error);
    throw error;
  }
};

export const getSpasByGuids = async (token: string | null, params: {page:string, guids:any[]}) => {
  try {
    const { data } = await axios.post(`${BASE_URL}/spas/by-guids${params.page}`, {
      guids: params.guids
    }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to fetch spas by GUIDs. ", error);
    throw error;
  }
};

export const getFieldHistoryApi = async (token: string | null, params: {guid:string, field_name?:string, page?:number}) => {
  try {
    const response = await axios.get(`${BASE_URL}/spas/${params.guid}/field-history${params.page ? `?page=${params.page}` : ''}${params.field_name ? `&field_name=${params.field_name}` : ''}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.log("Failed to pull field history. ", error);
    throw error;
  }
}

export const getFieldHistorySummaryApi = async (token: string | null, id:string) => {
  try {
    const response = await axios.get(`${BASE_URL}/spas/${id}/field-history/summary`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.log("Failed to pull field history summary. ", error);
    throw error;
  }
}